import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-mitteilung-optionen-festlegen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationRolleMitteilungOptionenFestlegenEffects {

    RolleMitteilungOptionenFestlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_MITTEILUNG_OPTIONEN_FESTLEGEN),
        mergeMap((x: ac.PostRolleMitteilungOptionenFestlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleMitteilungOptionenFestlegen(x.kommunikationRolleMitteilungOptionenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleMitteilungOptionenFestlegenErfolgreichAction(result, x.kommunikationRolleMitteilungOptionenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleMitteilungOptionenFestlegenFehlerAction(error, x.kommunikationRolleMitteilungOptionenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.KommunikationCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.KommunikationCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.KommunikationCommandService);
        }
        return this.service;
    }
}
